module.exports = __webpack_public_path__ + "img/settings.779833e9.svg";